import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery';
import { Collapse } from 'react-bootstrap';
import Permission from './RoleManagement/Permission';

export default function SideMenu() {
  const [activeMenu, setActiveMenu] = useState("");

  useEffect(() => {
    $('.nav-link').on('click', function () {
      $('.nav-link').removeClass('active');
      $(this).addClass('active');
    });

    return () => {
      $('.nav-link').off('click');
    };
  }, []);

  const handleMenuClick = (menu, event) => {
    event.preventDefault();
    setActiveMenu(activeMenu === menu ? "" : menu);
  };

  const handleChildClick = (event) => {
    event.stopPropagation();
  };


  return (
    <>
      <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-body-tertiary sidebar collapse">
        <div className="position-sticky pt-3 sidebar-sticky">
          <ul className="nav flex-column">
            <li className="nav-item">
              <Permission access={"/overview"}><Link to="/overview" className="nav-link " aria-current="page" > <i className="fa-solid fa-border-all"></i>Overview</Link></Permission>
            </li>
            <li className="nav-item">
              <Permission access={"/goal"}><Link to="/goal" className="nav-link " aria-current="page" > <i className="fa-solid fa-bullseye"></i>Goal </Link></Permission>
            </li>
            <li className="nav-item">
              <Permission access={"/teammanagement"}><Link to="teammanagement" className="nav-link " aria-current="page" > <i className="fa-solid fa-people-roof"></i>Team Management</Link></Permission>
            </li>
            <li className="nav-item">
              <Permission access={"/assets"}><Link to="/assets" className="nav-link " aria-current="page" > <i class="fa-solid fa-house-medical"></i>Company Assets </Link></Permission>
            </li>
            <li className="nav-item">
              <Permission access={"/supplier-tsp-report"}><Link to="/supplier-tsp-report" className="nav-link " aria-current="page" > <i class="fa-solid fa-industry"></i>Suppliers </Link></Permission>
            </li>

            {/* <Permission access={"/Suppliers"}> */}
            {/* <li className="nav-item" onClick={handleSubMenuClickSupplier}> */}
            {/* <div className="nav-link arrowdown" > <i class="fa-solid fa-industry"></i> Suppliers <span className='fa-solid fa-chevron-down'></span> */}
            {/* {showSubMenuSupplier && (<ul className="nav flex-column mb-2 ml-2 margin-left submenu-items"> */}

            {/* <li className="nav-item"> */}
            {/*<Permission access={"/tspsupplierreport"}>
                        <Link to="tspsupplierreport" className="nav-link">
                          <i className="fa-solid fa-file-lines"></i>
                          TSP
                        </Link>
                      </Permission>
                      <Permission access={"/suppliers"}>
                        <Link className="nav-link" to="suppliers">
                          <i className="fa-solid fa-file-lines"></i>
                          Supplier
                        </Link>
                      </Permission>
                      
                      {/* <Link className="nav-link" to="cdpqna">
                      <i className="fa-solid fa-file-lines"></i>
                      CDP
                    </Link>
                    <Link className="nav-link" to="griqna">
                      <i className="fa-solid fa-file-lines"></i>
                      GRI
                    </Link>
                    <Link className="nav-link" to="sasb">
                      <i className="fa-solid fa-file-lines"></i>
                      SASB
                    </Link> */}
            {/* </li> */}
            {/* <li className="nav-item" >
                    <Link to="demoreport" className="nav-link" >
                      <i className="fa-solid fa-file-lines"></i>
                      DemoReport
                    </Link>
                  </li>
                  <li className="nav-item" >
                    <Link to="demoreport1" className="nav-link" >
                      <i className="fa-solid fa-file-lines"></i>
                      DemoReport1
                    </Link>
                  </li>
                  <li className="nav-item" >
                    <Link to="demoreport2" className="nav-link" >
                      <i className="fa-solid fa-file-lines"></i>
                      DemoReport2
                    </Link>
                  </li> */}

            {/* <li className="nav-item" >
                    <Link className="nav-link" >
                      <i className="fa-solid fa-file-lines"></i>
                      CDP
                    </Link>
                  </li> */}
            {/* <li className="nav-item">
                    <Link to="grisupplierreport" className="nav-link">
                      <i className="fa-solid fa-file-lines"></i>
                      GRI
                    </Link>
                  </li> */}

            {/* </ul>)} */}
            {/* </div> */}
            {/* </li> */}
            {/* </Permission> */}
            {/* <li className="nav-item" onClick={handleSubMenuClick}>
              <div className="nav-link arrowdown"> <i className="fa-solid fa-file-contract"></i> Compliance <span className='fa-solid fa-chevron-down'></span>  {showSubMenu && (
                <ul className="nav mb-2 ml-2 submenu-items">
                  <li className="nav-item">
                    <Link className="nav-link" to="esgreport">
                      <i className="fa-solid fa-file-lines"></i>
                      ESG
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="sasbreport">
                      <i className="fa-solid fa-file-lines"></i>
                      SASB
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="grisupplierreport" className="nav-link">
                      <i className="fa-solid fa-file-lines"></i>
                      GRI
                    </Link>
                  </li> */}
            {/* <li className="nav-item">
                    <Link className="nav-link" to="cdp">
                      <i className="fa-solid fa-file-lines"></i>
                      CDP
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="gri">
                      <i className="fa-solid fa-file-lines"></i>
                      GRI
                    </Link>
                  </li>*/}
            {/* <li className="nav-item">
                    <Link className="nav-link" to="tspsupplierreportfinal">
                      <i className="fa-solid fa-file-lines"></i>
                      TSP
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="internal-reports">
                      <i className="fa-solid fa-file-lines"></i>
                      Internal Reports
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="supplier-reports">
                      <i className="fa-solid fa-file-lines"></i>
                      Supplier Reports
                    </Link>
                  </li>

                </ul>
              )}</div>
            </li> */}


            {/* <li className="nav-item">
              <Link to="importreport" className="nav-link " aria-current="page" > <i className="fa-solid fa-file-import"></i>Import Report</Link>
            </li> */}
            <Permission access={"/Internaldashboard"}>

              <li className="nav-item" onClick={(event) => handleMenuClick("internalDashboard", event)}>

                <div className="nav-link arrowdown" aria-current="page"> <i class="fa-solid fa-chart-bar"></i>Internal Dashboard <span className='fa-solid fa-chevron-down'></span>  {activeMenu === "internalDashboard" && (
                  <ul className="nav flex-column mb-2 ml-2">
                    <li className="nav-item" onClick={handleChildClick}>
                      <Permission access={"/internal-dashboards"}>
                        <Link className="nav-link" to="internal-dashboards">
                          <i className="fa-solid fa-file-lines"></i>Company Assets Dashboard
                        </Link>
                      </Permission>
                    </li>
                    <li className="nav-item" onClick={handleChildClick}>
                      <Permission access={"/supplier-dashboards"}>
                        <Link className="nav-link" to="supplier-dashboards">
                          <i className="fa-solid fa-file-lines"></i>Supplier Dashboard
                        </Link>
                      </Permission>
                    </li>
                  </ul>
                )}</div>
              </li>
            </Permission>

            <Permission access={"/External-reports"}>
              <li className="nav-item" onClick={(event) => handleMenuClick("externalDashboard", event)}>

                <div className="nav-link arrowdown" aria-current="page"> <i className="fa-solid fa-file-lines"></i>External Dashboard <span className='fa-solid fa-chevron-down'>
                  </span>  {activeMenu === "externalDashboard" && (
                  <ul className="nav flex-column mb-2 ml-2">
                    <li className="nav-item" onClick={handleChildClick}>
                      <Permission access={"/esg-dashboards"}>
                        <Link className="nav-link" to="esg-dashboards">
                          <i className="fa-solid fa-file-lines"></i>ESG Dashboard
                        </Link>
                      </Permission>
                   </li>
                   </ul>
                 )}</div>
                   </li>
                  </Permission>

            <Permission access={"/External-reports"}>
              <li className="nav-item" onClick={(event) => handleMenuClick("externalReports", event)}>

                <div className="nav-link arrowdown" aria-current="page"> <i className="fa-solid fa-table-columns"></i>Import Data <span className='fa-solid fa-chevron-down'></span>  {activeMenu === "externalReports" && (
                  <ul className="nav flex-column mb-2 ml-2">
                    <li className="nav-item" onClick={handleChildClick}>
                     
                      <Permission access={"/cdpqna"}>
                        <Link className="nav-link" to="cdpqna">
                          <i className="fa-solid fa-file-lines"></i>CDP
                        </Link>
                      </Permission>
                      <Permission access={"/griqna"}>
                        <Link className="nav-link" to="griqna">
                          <i className="fa-solid fa-file-lines"></i>GRI
                        </Link>
                      </Permission>
                      <Permission access={"/sasb"}>
                        <Link className="nav-link" to="sasb">
                          <i className="fa-solid fa-file-lines"></i>SASB
                        </Link>
                      </Permission>
                      <Permission access={"/sbti"}>
                        <Link className="nav-link" to="sbti">
                          <i className="fa-solid fa-file-lines"></i>SBTI
                        </Link>
                      </Permission>
                    </li>
                  </ul>
                )}</div>
              </li>
            </Permission>
            <Permission access={"/reports"}>
              <li className="nav-item">
                <Link to="/reports" className="nav-link " aria-current="page" > <i class="fa fa-file" aria-hidden="true"></i>Reports </Link>
              </li>
            </Permission>


            {/* <li className="nav-item">
              <Link to="dashboard" className="nav-link" aria-current="page" > <i className="fa-solid fa-table-columns"></i> Dashboard</Link>

            </li>

            <ul className="nav flex-column mb-2 ml-2">

              <li className="nav-item">
                <Link className="nav-link" to="internal-dashboards">
                  <i className="fa-solid fa-file-lines"></i>
                  Internal Dashboard
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="supplier-dashboards">
                  <i className="fa-solid fa-file-lines"></i>
                  Supplier Dashboard
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="esg-dashboards">
                  <i className="fa-solid fa-file-lines"></i>
                  ESG Dashboard
                </Link>
              </li>

            </ul> */}
            {JSON.parse(localStorage.getItem('userdetails')).role_name !== "SUPERADMIN" ?
              <Permission access={"/Access-control"}>
                <li className="nav-item" onClick={(event) => handleMenuClick("accessControl", event)}>
                  <div className="nav-link arrowdown" aria-current="page"> <i className="fa-solid fa-user-lock"></i>Access Control <span className='fa-solid fa-chevron-down'></span>  {activeMenu === "accessControl" && (
                    <ul className="nav flex-column mb-2 ml-2">
                      {/* <li className="nav-item" onClick={handleChildClick}>
                        <Permission access={"/create-user"}><Link className="nav-link" to="create-user">
                          <i className="fa-solid fa-file-lines"></i>
                          Create User
                        </Link></Permission>
                      </li> */}
                     {/*  <li className="nav-item" onClick={handleChildClick}>
                        <Permission access={"/create-role"}><Link className="nav-link" to="create-role">
                          <i className="fa-solid fa-file-lines"></i>
                          Create Role
                        </Link></Permission>
                      </li> */}
                      <li className="nav-item" onClick={handleChildClick}>
                        <Permission access={"/assign-permission"}><Link className="nav-link" to="assign-permission">
                          <i className="fa-solid fa-file-lines"></i>Assign Permission to Role
                        </Link></Permission>
                      </li>
                    </ul>
                  )}</div>
                </li>
              </Permission>
              : <li className="nav-item" onClick={(event) => handleMenuClick("accessControl", event)}>
                <div className="nav-link arrowdown" aria-current="page"> <i className="fa-solid fa-user-lock"></i>Access Control <span className='fa-solid fa-chevron-down'></span>  {activeMenu === "accessControl" && (
                  <ul className="nav flex-column mb-2 ml-2">
                    {/*<li className="nav-item" onClick={handleChildClick}>
                      <Link className="nav-link" to="create-user">
                        <i className="fa-solid fa-file-lines"></i>
                        Create User
                      </Link>
                    </li>*/}
                   {/* <li className="nav-item" onClick={handleChildClick}>
                      <Link className="nav-link" to="create-role">
                        <i className="fa-solid fa-file-lines"></i>
                        Create Role
                      </Link>
                    </li> */}
                    <li className="nav-item" onClick={handleChildClick}>
                      <Link className="nav-link" to="assign-permission">
                        <i className="fa-solid fa-file-lines"></i>Assign Permission to Role
                      </Link>
                    </li>
                  </ul>
                )}</div>
              </li>}
          </ul>
        </div>
      </nav>
    </>
  )
}
